import angular from 'angular';
import userGroupMemberships from 'user/components/group-memberships/user-group-memberships-module';
import MyAccountComponent from './my-account-component';
import MyAccountFormComponent from './components/form/my-account-form-component';

export default angular
  .module('my-account', [userGroupMemberships.name])
  .component('myAccount', new MyAccountComponent())
  .component('myAccountForm', new MyAccountFormComponent());



// WEBPACK FOOTER //
// ./src/modules/user/components/my-account/my-account-module.js